import React from 'react';

import Spinner from '~components/Spinner';

interface ComponentProps {
  colSpan: number;
}

const TableLoading: React.FC<ComponentProps> = ({ colSpan }) => {
  return (
    <tr>
      <td colSpan={colSpan}>
        <Spinner loading className="spinner-container" />
      </td>
    </tr>
  );
};

export default TableLoading;
